import { css } from "styled-components";

// 기기 사이즈
export const size = {
	mobileS: "320px",
	mobileM: "375px",
	mobileL: "425px",
	tablet: "768px",
	laptop: "1024px",
	laptopL: "1440px",
	desktop: "2560px",
};

// 미디어 스타일
const theme = {
	mobileS: `(max-width: ${size.mobileS})`,
	mobileM: `(max-width: ${size.mobileM})`,
	mobileL: `(max-width: ${size.mobileL})`,
	tablet: `(max-width: ${size.tablet})`,
	laptop: `(max-width: ${size.laptop})`,
	laptopL: `(max-width: ${size.laptopL})`,
	desktop: `(min-width: ${size.desktop})`,
	desktopL: `(min-width: ${size.desktop})`,
};

// color
export const color = {
	white: "#ffffff",
	black: "#181a1e",
	gray: "#2c2f36",
	darkGray: "#212225",
	point: "#c24100",
	subPoint: "#1deac6",
	blue: "#586aff",
};

// flex 디자인
export const flexCenter = css`
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const flexCenterDir = css`
	${flexCenter}

	flex-direction: column;
`;

export const overflowY = css`
	overflow-y: auto;
	::-webkit-scrollbar {
		display: none;
	}
`;

export const fadeIn = css`
	animation: fade-in 3s;

	@keyframes fade-in {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
`;

export const FormStyle = css`
	display: flex;
	justify-content: center;
	align-items: center;
	letter-spacing: 0.2rem;

	span {
		margin-top: 0.3rem;
	}

	.point {
		color: ${color.subPoint};
		font-size: 3rem;
		margin: 0;
		padding: 0;
	}

	input {
		${flexCenter}
		padding: 0;
		margin: 0;
		text-align: center;
		font-size: 1.5rem;
		font-weight: bold;
		color: ${color.subPoint};

		&::placeholder {
			font-size: 1.5rem;
			font-weight: bold;
			color: ${color.subPoint};
		}
	}

	button {
		margin-left: 3rem;
		width: 2rem;
		height: 2rem;
		border-radius: 11px;
		border: 3px solid ${color.subPoint};
		box-shadow: 0px 0.5px 10px ${color.subPoint};
		transition: all 0.6s ease 0s;

		&:hover {
			background: ${color.subPoint};
		}
	}
`;

export default theme;
